module.exports = __webpack_public_path__ + "static/img/gptnew3.194cbfb0.png";